"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useMatch } from "fansunited-data-layer/client";
import { PillToggle } from "@/components/ui/controls/PillToggle";
import { MatchLineupField } from "../partials/lineups/MatchLineupField";
import { MatchLineups } from "../partials/lineups/MatchLineups";
interface LineupsTabProps {
  homeTeamName: string;
  awayTeamName: string;
  homeTeamCode?: string;
  awayTeamCode?: string;
  homeTeamLogo?: string;
  awayTeamLogo?: string;
  homeTeamCountryCode?: string;
  homeTeamCountryFlag?: string;
  homeTeamPrimaryColor?: string;
  homeTeamSecondaryColor?: string;
  awayTeamCountryCode?: string;
  awayTeamCountryFlag?: string;
  awayTeamPrimaryColor?: string;
  awayTeamSecondaryColor?: string;
}

/**
 * LineupsTab - Displays the lineup field visualization and player lists
 * Desktop: Both teams side by side
 * Mobile: Team toggle controls both formation field and lineup list
 */
export const LineupsTab: React.FC<LineupsTabProps> = t0 => {
  const $ = _c(79);
  const {
    homeTeamName,
    awayTeamName,
    homeTeamCode,
    awayTeamCode,
    homeTeamLogo,
    awayTeamLogo,
    homeTeamCountryCode,
    homeTeamCountryFlag,
    homeTeamPrimaryColor,
    homeTeamSecondaryColor,
    awayTeamCountryCode,
    awayTeamCountryFlag,
    awayTeamPrimaryColor,
    awayTeamSecondaryColor
  } = t0;
  const {
    lineups
  } = useMatch();
  const [activeTeam, setActiveTeam] = useState("home");
  if (!lineups || !lineups.confirmed) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="text-center py-12 text-muted-foreground">Lineup data is not available for this match.</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== homeTeamName) {
    t1 = {
      id: "home" as const,
      label: homeTeamName
    };
    $[1] = homeTeamName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== awayTeamName) {
    t2 = {
      id: "away" as const,
      label: awayTeamName
    };
    $[3] = awayTeamName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = [t1, t2];
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const teamOptions = t3;
  let t4;
  if ($[8] !== awayTeamCode || $[9] !== awayTeamCountryCode || $[10] !== awayTeamCountryFlag || $[11] !== awayTeamLogo || $[12] !== awayTeamName || $[13] !== awayTeamPrimaryColor || $[14] !== awayTeamSecondaryColor || $[15] !== homeTeamCode || $[16] !== homeTeamCountryCode || $[17] !== homeTeamCountryFlag || $[18] !== homeTeamLogo || $[19] !== homeTeamName || $[20] !== homeTeamPrimaryColor || $[21] !== homeTeamSecondaryColor) {
    t4 = <MatchLineupField homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamCode={homeTeamCode} awayTeamCode={awayTeamCode} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamCountryCode={homeTeamCountryCode} homeTeamCountryFlag={homeTeamCountryFlag} homeTeamPrimaryColor={homeTeamPrimaryColor} homeTeamSecondaryColor={homeTeamSecondaryColor} awayTeamCountryCode={awayTeamCountryCode} awayTeamCountryFlag={awayTeamCountryFlag} awayTeamPrimaryColor={awayTeamPrimaryColor} awayTeamSecondaryColor={awayTeamSecondaryColor} />;
    $[8] = awayTeamCode;
    $[9] = awayTeamCountryCode;
    $[10] = awayTeamCountryFlag;
    $[11] = awayTeamLogo;
    $[12] = awayTeamName;
    $[13] = awayTeamPrimaryColor;
    $[14] = awayTeamSecondaryColor;
    $[15] = homeTeamCode;
    $[16] = homeTeamCountryCode;
    $[17] = homeTeamCountryFlag;
    $[18] = homeTeamLogo;
    $[19] = homeTeamName;
    $[20] = homeTeamPrimaryColor;
    $[21] = homeTeamSecondaryColor;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== awayTeamCountryCode || $[24] !== awayTeamCountryFlag || $[25] !== awayTeamLogo || $[26] !== awayTeamName || $[27] !== awayTeamPrimaryColor || $[28] !== awayTeamSecondaryColor || $[29] !== homeTeamCountryCode || $[30] !== homeTeamCountryFlag || $[31] !== homeTeamLogo || $[32] !== homeTeamName || $[33] !== homeTeamPrimaryColor || $[34] !== homeTeamSecondaryColor) {
    t5 = <MatchLineups homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamCountryCode={homeTeamCountryCode} homeTeamCountryFlag={homeTeamCountryFlag} homeTeamPrimaryColor={homeTeamPrimaryColor} homeTeamSecondaryColor={homeTeamSecondaryColor} awayTeamCountryCode={awayTeamCountryCode} awayTeamCountryFlag={awayTeamCountryFlag} awayTeamPrimaryColor={awayTeamPrimaryColor} awayTeamSecondaryColor={awayTeamSecondaryColor} />;
    $[23] = awayTeamCountryCode;
    $[24] = awayTeamCountryFlag;
    $[25] = awayTeamLogo;
    $[26] = awayTeamName;
    $[27] = awayTeamPrimaryColor;
    $[28] = awayTeamSecondaryColor;
    $[29] = homeTeamCountryCode;
    $[30] = homeTeamCountryFlag;
    $[31] = homeTeamLogo;
    $[32] = homeTeamName;
    $[33] = homeTeamPrimaryColor;
    $[34] = homeTeamSecondaryColor;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  let t6;
  if ($[36] !== t4 || $[37] !== t5) {
    t6 = <div className="hidden md:block space-y-6">{t4}{t5}</div>;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== activeTeam || $[40] !== teamOptions) {
    t7 = <div className="mb-6 flex justify-center"><PillToggle options={teamOptions} activeId={activeTeam} onChange={setActiveTeam} size="sm" /></div>;
    $[39] = activeTeam;
    $[40] = teamOptions;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  let t8;
  if ($[42] !== activeTeam || $[43] !== awayTeamCode || $[44] !== awayTeamCountryCode || $[45] !== awayTeamCountryFlag || $[46] !== awayTeamLogo || $[47] !== awayTeamName || $[48] !== awayTeamPrimaryColor || $[49] !== awayTeamSecondaryColor || $[50] !== homeTeamCode || $[51] !== homeTeamCountryCode || $[52] !== homeTeamCountryFlag || $[53] !== homeTeamLogo || $[54] !== homeTeamName || $[55] !== homeTeamPrimaryColor || $[56] !== homeTeamSecondaryColor) {
    t8 = <MatchLineupField homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamCode={homeTeamCode} awayTeamCode={awayTeamCode} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamCountryCode={homeTeamCountryCode} homeTeamCountryFlag={homeTeamCountryFlag} homeTeamPrimaryColor={homeTeamPrimaryColor} homeTeamSecondaryColor={homeTeamSecondaryColor} awayTeamCountryCode={awayTeamCountryCode} awayTeamCountryFlag={awayTeamCountryFlag} awayTeamPrimaryColor={awayTeamPrimaryColor} awayTeamSecondaryColor={awayTeamSecondaryColor} activeTeam={activeTeam} />;
    $[42] = activeTeam;
    $[43] = awayTeamCode;
    $[44] = awayTeamCountryCode;
    $[45] = awayTeamCountryFlag;
    $[46] = awayTeamLogo;
    $[47] = awayTeamName;
    $[48] = awayTeamPrimaryColor;
    $[49] = awayTeamSecondaryColor;
    $[50] = homeTeamCode;
    $[51] = homeTeamCountryCode;
    $[52] = homeTeamCountryFlag;
    $[53] = homeTeamLogo;
    $[54] = homeTeamName;
    $[55] = homeTeamPrimaryColor;
    $[56] = homeTeamSecondaryColor;
    $[57] = t8;
  } else {
    t8 = $[57];
  }
  let t9;
  if ($[58] !== activeTeam || $[59] !== awayTeamCountryCode || $[60] !== awayTeamCountryFlag || $[61] !== awayTeamLogo || $[62] !== awayTeamName || $[63] !== awayTeamPrimaryColor || $[64] !== awayTeamSecondaryColor || $[65] !== homeTeamCountryCode || $[66] !== homeTeamCountryFlag || $[67] !== homeTeamLogo || $[68] !== homeTeamName || $[69] !== homeTeamPrimaryColor || $[70] !== homeTeamSecondaryColor) {
    t9 = <MatchLineups homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamCountryCode={homeTeamCountryCode} homeTeamCountryFlag={homeTeamCountryFlag} homeTeamPrimaryColor={homeTeamPrimaryColor} homeTeamSecondaryColor={homeTeamSecondaryColor} awayTeamCountryCode={awayTeamCountryCode} awayTeamCountryFlag={awayTeamCountryFlag} awayTeamPrimaryColor={awayTeamPrimaryColor} awayTeamSecondaryColor={awayTeamSecondaryColor} activeTeam={activeTeam} />;
    $[58] = activeTeam;
    $[59] = awayTeamCountryCode;
    $[60] = awayTeamCountryFlag;
    $[61] = awayTeamLogo;
    $[62] = awayTeamName;
    $[63] = awayTeamPrimaryColor;
    $[64] = awayTeamSecondaryColor;
    $[65] = homeTeamCountryCode;
    $[66] = homeTeamCountryFlag;
    $[67] = homeTeamLogo;
    $[68] = homeTeamName;
    $[69] = homeTeamPrimaryColor;
    $[70] = homeTeamSecondaryColor;
    $[71] = t9;
  } else {
    t9 = $[71];
  }
  let t10;
  if ($[72] !== t7 || $[73] !== t8 || $[74] !== t9) {
    t10 = <div className="block md:hidden space-y-4">{t7}{t8}{t9}</div>;
    $[72] = t7;
    $[73] = t8;
    $[74] = t9;
    $[75] = t10;
  } else {
    t10 = $[75];
  }
  let t11;
  if ($[76] !== t10 || $[77] !== t6) {
    t11 = <>{t6}{t10}</>;
    $[76] = t10;
    $[77] = t6;
    $[78] = t11;
  } else {
    t11 = $[78];
  }
  return t11;
};

/**
 * Hook to check if lineups tab should be shown
 */
export const useHasLineups = () => {
  const {
    lineups
  } = useMatch();
  return lineups && lineups.confirmed;
};